export default {
  title: {
    id: 'bo_seller.orders.drawers.fix_order_issue.cancel_order_lines_title',
    defaultMessage: 'Next step: Cancel order.',
  },
  subtitle: {
    id: 'bo_seller.orders.drawers.fix_order_issue.cancel_order_lines_subtitle',
    defaultMessage:
      "This action can't be undone. We'll notify your customer of the cancellation.",
  },
  orderInfo: {
    id: 'bo_seller.orders.drawers.fix_order_issue.cancel_order_lines_order_info',
    defaultMessage: 'Order',
  },
  customer: {
    id: 'bo_seller.orders.drawers.fix_order_issue.cancel_order_lines_customer',
    defaultMessage: 'Customer',
  },
  orderDate: {
    id: 'bo_seller.orders.drawers.fix_order_issue.cancel_order_lines_order_date',
    defaultMessage: 'Order date',
  },
  sku: {
    id: 'bo_seller.orders.drawers.fix_order_issue.cancel_order_lines_sku',
    defaultMessage: 'SKU',
  },
  quantity: {
    id: 'bo_seller.orders.drawers.fix_order_issue.cancel_order_lines_quantity',
    defaultMessage: 'Quantity',
  },
  appearance: {
    id: 'bo_seller.orders.drawers.fix_order_issue.cancel_order_lines_appearance',
    defaultMessage: 'Appearance',
  },
  grade: {
    id: 'bo_seller.orders.drawers.fix_order_issue.cancel_order_lines_grade',
    defaultMessage: 'Grade',
  },
  stockWarning: {
    id: 'bo_seller.orders.drawers.fix_order_issue.cancel_order_lines_stock_warning',
    defaultMessage:
      'Once you select "Cancel order", the stock for this listing will be set to 0.',
  },
  cancelOrder: {
    id: 'bo_seller.orders.drawers.fix_order_issue.cancel_order_lines_cancel_button',
    defaultMessage: 'Cancel order',
  },
  successMessageTitle: {
    id: 'bo_seller.orders.drawers.fix_order_issue.cancel_order_lines_success_message_title',
    defaultMessage: 'Order canceled.',
  },
  successMessageContent: {
    id: 'bo_seller.orders.drawers.fix_order_issue.cancel_order_lines_success_message_content',
    defaultMessage: 'We’ve notified your customer of the cancellation.',
  },
} as const
